import React from 'react'

const CourseSelection = ({ course_types = [], setSelectedCourse,
    setProvisionalLicence, setCarType, errors , cartype , Licence , Course,setSelectedInstructor }) => {

    return (
        <div>
            <div>
                <h2 className='pt-3 pb-2 fs-2 fw-semibold'>The Fundamentals</h2>
                <p>Just a few questions to determine the type of lesson or course you would like.</p>
            </div>

            <div>
                <div className='mt-5'>
                    <div className='row'>
                        {/* <div className="col-md-6 ">
                            <div>
                                <label htmlFor="">Do you have a provisional licence? *</label>
                                <div className='row'>
                                    {
                                        errors?.provisional_licence &&
                                        <div className="col-12 mt-2">
                                            <div className='text-danger alert mb-0 p-0 badge text-start'>{errors?.provisional_licence}</div>
                                        </div>
                                    }
                                    <div className='col-md-6'>
                                        <div className='input-white-box'>
                                            <input type="radio" checked={Licence === 'Yes'} onChange={(e) => setProvisionalLicence('Yes')} className='custom-radio-btn' name='licence' id='licence1' />
                                            <label htmlFor="licence1" >Yes</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='input-white-box'>
                                            <input type="radio" checked={Licence === 'No'} onChange={(e) => setProvisionalLicence('No')} className='custom-radio-btn' name='licence' id='licence2' />
                                            <label htmlFor="licence2" >No</label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div> */}

                        <div className="col-md-6 mt-md-0 mt-5">
                            <div>
                                <label htmlFor="">Car type required *</label>
                                <div className='row'>
                                    {
                                        errors?.car_type &&
                                        <div className="col-12 mt-2">
                                            <div className='text-danger alert mb-0 p-0 badge text-start'>{errors?.car_type}</div>
                                        </div>
                                    }
                                    <div className='col-md-6 '>
                                        <div className='input-white-box'>
                                            <input type="radio" checked={cartype === 'Manual'} onChange={(e) => setCarType("Manual")} className='custom-radio-btn' name='cartype' id='cartype1' />
                                            <label htmlFor="cartype1" >Manual </label>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='input-white-box'>
                                            <input type="radio" checked={cartype === 'Automatic'} onChange={(e) => setCarType("Automatic")} className='custom-radio-btn' name='cartype' id='cartype2' />
                                            <label htmlFor="cartype2" >Automatic</label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="col-12 mt-md-4 mt-5">
                            <div>
                                <label htmlFor="">Select Course *</label>
                                <div className='row'>
                                    {
                                        errors?.selected_course &&
                                        <div className="col-12 mt-2">
                                            <div className='text-danger alert mb-0 p-0 badge text-start'>{errors?.selected_course}</div>
                                        </div>
                                    }
                                    {
                                        cartype ? (
                                            (course_types && course_types.length > 0) ? (
                                                course_types.filter(course => course.cartype == cartype).length > 0 ? (
                                                    course_types.filter(course => course.cartype == cartype).map((course_type, index) => {
                                                        return (
                                                            <div className='col-md-6' key={course_type?.id}>
                                                                <div className='input-white-box'>
                                                                    <input type="radio"
                                                                        className='custom-radio-btn'
                                                                        name='course_type'
                                                                        checked={Course?.id == course_type?.id}
                                                                        id={`course_type${index}`}
                                                                        onChange={(e) => {
                                                                            setSelectedInstructor({})
                                                                            setSelectedCourse(course_type)
                                                                        } }
                                                                    />
                                                                    <label htmlFor={`course_type${index}`} >
                                                                        £ <b>{course_type.price}</b> | {course_type.title}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <div className='col-md-6'>
                                                        <div className='input-white-box'>
                                                            <label htmlFor={`course_type`}>
                                                                No Course Available
                                                            </label>
                                                        </div>
                                                    </div>
                                                )
                                            ) : (
                                                <div className='col-md-6'>
                                                    <div className='input-white-box'>
                                                        <label htmlFor={`course_type`}>
                                                            No Course Available
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        ) : (
                                            <div className='col-md-6'>
                                                <div className='input-white-box'>
                                                    <label htmlFor={`course_type`}>
                                                        Select Car Type First
                                                    </label>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CourseSelection